/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { SECTION_SET } from 'state/action-types';
import route from './route/reducer';
import modal from './modal/reducer';
import syncResource from './sync-resource/reducer';
import locationGroupModal from './location-group-modal/reducer';
import locationModal from './location-modal/reducer';
import syncResourceConnectModal from './sync-resource-connect-modal/reducer';
import resourceInfoModal from './resource-info-modal/reducer';
import resourceMetaDataModal from './resource-meta-data-modal/reducer';
import operationDetailsModal from './operation-details-modal/reducer';
import locationWebsiteModal from './location-website-modal/reducer';
import salesTypesModal from './sales-types-modal/reducer';
import paymentTypesModal from './payment-types-modal/reducer';

export const section = (state = false, action) => {
    switch (action.type) {
        case SECTION_SET:
            return action.section !== undefined ? action.section : state;
        default:
            return state;
    }
};

export const isLoading = (state = false, action) => {
    switch (action.type) {
        case SECTION_SET:
            return action.isLoading !== undefined ? action.isLoading : state;
        default:
            return state;
    }
};

const reducer = combineReducers({
    modal,
    route,
    section,
    isLoading,
    locationGroupModal,
    locationModal,
    operationDetailsModal,
    syncResource,
    syncResourceConnectModal,
    resourceMetaDataModal,
    resourceInfoModal,
    locationWebsiteModal,
    salesTypesModal,
    paymentTypesModal,
});

export default reducer;
